module.exports = __webpack_public_path__ + "img/iconCC-Social6.00b59925.png";